import { render, staticRenderFns } from "./article.vue?vue&type=template&id=2f7f113a&scoped=true&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/article.scss?vue&type=style&index=0&id=2f7f113a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7f113a",
  null
  
)

export default component.exports